import axios from "axios";
import config from "config/index";
import { getGlobal } from "config/global";
import { toast } from 'react-toastify';
let host = config.host + "/api/"
let apikey = config.apikey
// initializing the axios instance with custom configs
export default function (address,id,title, data) {
    let token = localStorage.getItem("token")
    return axios.post(host + `tour/EditPopUp`, {
        address,id, data, title
    },
        {
            headers: {
                "Content-Type": "application/json",
                "ApiKey": apikey,
                "Authorization": "Bearer " + token
            }
        }).then((response) => {
            return response.data
        }).catch((err) => {
            if (err?.response?.status == 401)
                { localStorage.removeItem("token"); window.location=("/auth/signin"); return toast.error("لطفا مجددا لاگین کنید.", {position: "bottom-right"})}
            else
            throw err;
        })
}